import { DirectiveDescriptor, insertDirective$, useMdastNodeUpdater, usePublisher } from "@mdxeditor/editor";
import { MyText } from "../../../MyText/MyText";
import { EditBtn, ModalLatexText, ModalTop, MyDirectiveDiv, RemoveLatex } from "./styles";
import { Button, Flex, Input, Modal, notification } from "antd";
import { CloseCircleFilled, EditOutlined } from "@ant-design/icons";
import { useState } from "react";
import { MyLatexComponent } from "./MyLatex";

// Модуль для @mdxeditor/editor (директива) , версия ^3.11.1
// Пример https://mdxeditor.dev/editor/docs/custom-directive-editors
// для формирования TeX используется  react-latex-next , версия ^3.0.0
// так ant-design , версия ^5.18.0
// directivesPlugin({ directiveDescriptors: [LatexDirectiveFn(disabled)] }) 
const LatexDirectiveFn = (showActions: boolean) => {
    const LatexDirective: DirectiveDescriptor = {
        name: 'latex',
        testNode(node) {
            return node.name === 'latex'
        },
        attributes: [],
        hasChildren: true,
        Editor: (props) => {
            const updateNode = useMdastNodeUpdater();

            return (
                <MyDirectiveDiv>
                    <Flex>
                        <MyLatexComponent text={props.mdastNode?.attributes?.latex}></MyLatexComponent>
                        {
                            !showActions &&
                            <>
                                <LatexButton updateNode={(text: any) => updateNode({ attributes: { latex: text } })} node={props.lexicalNode} initText={props.mdastNode?.attributes?.latex}></LatexButton>
                                <RemoveLatex onClick={() => {
                                    props.parentEditor.update(() => {
                                        const node = props.lexicalNode;
                                        if (node) {
                                            node.remove();
                                        }
                                    })
                                }}> <CloseCircleFilled /></RemoveLatex>
                            </>
                        }
                    </Flex>
                </MyDirectiveDiv>
            )
        }
    }

    return LatexDirective;

}


// toolbarPlugin -> toolbarContents
const LatexButton = ({ initText, updateNode }: any) => {
    const insertDirective = usePublisher(insertDirective$)
    const [modalOpen, setModalOpen] = useState(false)
    const [valueTeX, setValTeX] = useState(initText)
    const { TextArea } = Input;
    const [api, contextHolder] = notification.useNotification();
    const modalReset = () => {
        setModalOpen(false)
        setValTeX("")
    }
    return (
        <>
            {/* contextHolder это нужно для уведомления  */}
            {contextHolder}
            {
                updateNode ?
                    <EditBtn onClick={() => setModalOpen(true)}><EditOutlined /></EditBtn>
                    :
                    <Button type="link" onClick={() => setModalOpen(true)}>
                        TeX
                    </Button>
            }

            <Modal cancelText="Отмена" open={modalOpen} onOk={() => {
                if (!valueTeX.length) {
                    api.error({
                        message: `Поле ТеХ не может быть пустым`,
                        placement: 'bottomRight'
                    });
                    return;
                }

                if (updateNode) {
                    updateNode(valueTeX);
                } else {
                    insertDirective({
                        name: 'latex',
                        type: 'textDirective',
                        attributes: { latex: valueTeX }
                    })
                }
                modalReset()
            }} onCancel={() => { modalReset() }}>
                <ModalTop >Математика в ТеХ-системе</ModalTop>
                <MyText>Введите здесь Тех</MyText>
                <TextArea value={valueTeX} onChange={(e) => setValTeX(e.target.value)} rows={4} />
                <ModalLatexText>
                    <MyLatexComponent text={valueTeX}></MyLatexComponent>
                </ModalLatexText>
            </Modal>
        </>
    )
}

export { LatexDirectiveFn, LatexButton }